import { useMemo } from 'react';
import { useAlertStatuses } from '../alertStatusesHelper';

const useAlertStatus = (id: number) => {
  const [, statuses] = useAlertStatuses();

  return useMemo(() => statuses.find((status) => status.id === id), [id, statuses]);
};

export default useAlertStatus;
